<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    import {
        connect as connectMqtt
    } from "./mqtt/index";
    import {
        connect as alarmConnect,
        subscribe
    } from "./mqtt/alarm";
    import {play} from './api/login'
    import { userAllgroup,firmInfo } from './api/power.js'

    export default {
        name: "App",
        beforeCreate() {
            //在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem("storeweb")) {
                // if(this.$cookies.get('isLogin')){
                    this.$store.replaceState(
                        Object.assign({},
                            this.$store.state,
                            JSON.parse(sessionStorage.getItem("storeweb"))
                        )
                    );
                }
        },
        created() {
            //在页面刷新时将vuex里的信息保存到sessionStorage里
            window.addEventListener("beforeunload", () => {
                let obj = {
                    token:{
                        isLogin:this.$store.state.token.isLogin,
                        token:this.$store.state.token.token
                    }
                }
                sessionStorage.setItem("storeweb", JSON.stringify(this.$store.state));
            });
            // if(this.$cookies.get('isLogin')&&!sessionStorage.getItem("storeweb")){
            //     let data = this.$cookies.get('logincookies')
            //     this.loginSuccess(data)
            // }
            
        },
        mounted() {
            let html = document.getElementsByTagName("html")[0];
            this.reset(html);
            window.onresize = () => {
                this.reset(html);
            };
            alarmConnect();
            connectMqtt();
        },
        methods: {
            
			getWeatherInfo() {
                let WeatherInfo = {}
                fetch('https://devapi.heweather.net/v7/weather/now?location=' + this.$store.state.project.projectInfo.projectCoordinate +
                    '&key=aa0dc97c8180424b91a79c7a0fe136ef')
                .then(response => response.json())
                .then(json => {
                    WeatherInfo.text = json.now.text
                    WeatherInfo.temp = json.now.temp
                    WeatherInfo.humidity = json.now.humidity
                    this.$store.commit("setWeatherInfo", WeatherInfo);
                })
                fetch('https://devapi.qweather.com/v7/air/now?location=' + this.$store.state.project.projectInfo.projectCoordinate +
                    '&key=aa0dc97c8180424b91a79c7a0fe136ef')
                .then(response => response.json())
                .then(json => {
                    WeatherInfo.category = json.now.category;
                    this.$store.commit("setWeatherInfo", WeatherInfo);
                })
                // fetch('https://api.qweather.com/v7/solar-radiation/24h?location=' + this.$store.state.project.projectInfo.projectCoordinate +
                //     '&key=aa0dc97c8180424b91a79c7a0fe136ef')
                // .then(response => response.json())
                // .then(json => {

                //     WeatherInfo.category = json.now.category;
                //     this.$store.commit("setWeatherInfo", WeatherInfo);
                // })
            },
            loginSuccess(res){

                let token = res.data.data.token;
                this.$store.commit("setToken", token);
                window.sessionStorage.setItem('token', token)
                // 刷新 token
                setInterval(() => {
                    play.freshToken().then((res) => {
                        this.$store.commit("setToken", res.data.data
                            .token);
                    });
                }, 45 * 60 * 1000);



                this.$store.commit("setUser", res.data.data.user);
                this.$store.commit("setProjectId", res.data.data.user.firmId);
                userAllgroup(res.data.data.user.uid).then((res) => {
                    if(res.data.status){

                    let projectGroup = res.data.data
                    // let areaId = projectGroup[0].projectList[0].areaList[0].areaId
                    let projectId = projectGroup[0].projectList[0].projectId
                    
                    this.$store.commit("setProjectId", projectId);
                    let newprojectGroup = projectGroup.filter(e=>{if(e.firmId != projectGroup[0].firmId)return e})
                    this.$store.commit("setProjectGroup", projectGroup);
                    // this.$store.commit("setAreaInfo", projectGroup[0].projectList[0].areaList[0]);
                    this.$store.commit("setEnterpriseInfo",projectGroup[0]);
                    
                    this.$store.commit(
                        "setProjectInfo",
                        projectGroup[0].projectList[0]
                    );
                    
                    this.getWeatherInfo();
                    sessionStorage.setItem('isSelect', "Overview") 
                    this.$router.push("/Home/Overview/SubstationManagement");
                    
                }else{
                    this.$message.error(res.data.errMsg);
                }

                })

                //判断前后台数据
                this.$store.commit("ForegroundRadio", this.ruleForm.radio1);
                this.$store.commit("NavformDataId", 1);
                sessionStorage.setItem("NavformDataId", 1)
            },
            reset(html) {
                if (window.innerWidth * window.innerHeight <= 1920 * 1080) {
                    html.style.fontSize =
                        (window.innerWidth * window.innerHeight) / 1920 / 1080 + "px";
                    //html.style.fontSize = window.innerWidth / 1920 + 'px'
                } else {
                    html.style.fontSize =
                        (window.innerWidth * window.innerHeight) / 1920 / 1080 / 2 + "px";
                    //html.style.fontSize = window.innerWidth / 1920 + 'px'
                }
            }, 
        },
    };
</script>
<style lang="less">
    @import "assets/css/global";
    @import "assets/css/func";
    @import "./assets/fonts/font.css";
  
</style>